export enum RouteSaveAction {
  UPDATE = 'update',
  SCHEDULE = 'schedule',
  DRAFT = 'draft'
}
